/**
 * Payout Mobile Simulate — embeds the same prototype as mobile/PaySafeMobile.jsx
 * (login, home, payout MJ1 flow, incident MJ2, alerts, tab bar). Routes /capture
 * remain available for ops; simulator is reachable by URL when needed.
 */

import React from 'react';
import PaySafeMobile from '@mobile/PaySafeMobile.jsx';

export default function PayoutMobileSimulate() {
  return (
    <div className="flex flex-col items-center justify-start min-h-[calc(100vh-5rem)] bg-slate-100 py-6 px-4 pb-12">
      <p className="text-sm text-slate-600 mb-4 text-center max-w-lg">
        Same UI as the standalone mobile app in{' '}
        <code className="bg-slate-200 px-1.5 py-0.5 rounded text-slate-800 text-xs">mobile/PaySafeMobile.jsx</code>
        — use any non-empty credentials on the login screen, then Home, Payout, Incident, Alerts.
      </p>
      <div className="flex justify-center w-full">
        <PaySafeMobile />
      </div>
    </div>
  );
}
